import { render, staticRenderFns } from "./MessageList.vue?vue&type=template&id=f7d020e8&scoped=true&lang=pug"
import script from "./MessageList.vue?vue&type=script&lang=ts"
export * from "./MessageList.vue?vue&type=script&lang=ts"
import style0 from "./MessageList.vue?vue&type=style&index=0&id=f7d020e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7d020e8",
  null
  
)

export default component.exports